import React from "react"
import Landing from "components/landing"
import CustomCursor from "components/customCursor"
import "./layout.scss"

function Layout({ children }) {
  return (
    <>
      <CustomCursor />
      <Landing />
      <div
        style={{
          paddingTop: 0,
        }}
      >
        <main>{children}</main>
      </div>
    </>
  )
}

export default Layout
